import React from "react";
import { useTranslation } from "react-i18next"; // ✅ Import translation hook
import PhotoSlider from "../../components/PhotoSlider/PhotoSlider";
import CourseDetails from "./CourseDetails";

// ✅ Import both language versions
import { Programs as ProgramsEN } from "../../data/programs"; 
import { Programs as ProgramsRU } from "../../data/ruprograms"; 
import { t } from "i18next";

const CourseCarousel: React.FC = () => {
  const { i18n } = useTranslation(); // ✅ Get current language
  const isRussian = i18n.language === "ru"; // ✅ Check if Russian is selected
  const Programs = isRussian ? ProgramsRU : ProgramsEN; // ✅ Use correct data set

  // ✅ Extract all events and include programId for each event
  const allEvents = Programs.flatMap((program) =>
    program.events.map((event) => ({
      ...event,
      programId: program.id,
    }))
  );

  const today = new Date();
  today.setHours(0, 0, 0, 0); // Ensure we compare only the date part
  
  const sortedEvents = allEvents
    .filter((event) => {
      const eventDate = new Date(event.dateOfEvent);
      eventDate.setHours(0, 0, 0, 0); // Normalize event date for comparison
      return eventDate >= today; // Only keep today or future events
    })
    .sort((a, b) => new Date(a.dateOfEvent).getTime() - new Date(b.dateOfEvent).getTime());
  

  const mostRecentEvent = sortedEvents[0];

  // ✅ Dynamically collect images from the event
  const homeImages = [
    mostRecentEvent?.image,
    mostRecentEvent?.image2,
    mostRecentEvent?.image3,
  ].filter(Boolean);

  return (
    <div style={styles.sectionContainer}>
      <div style={styles.container}>
        {homeImages.length > 0 ? (
          <PhotoSlider images={homeImages as string[]} />
        ) : (
          <p >No images available</p>
        )}

        {mostRecentEvent ? (
          <CourseDetails
          title={mostRecentEvent.name}
          location={mostRecentEvent.location}
          description={mostRecentEvent.description || t("noDescription")}
          dateRange={`${mostRecentEvent.date} ${t("at")} ${mostRecentEvent.time}`} // ✅ Translate "at"
          isPro={true}
          eventLink={`/program/${mostRecentEvent.programId}/event/${mostRecentEvent.id}`}
        />
        
        ) : (
          <p>No upcoming events</p>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: "#000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  text: {
    color: "#fff",
    fontSize: "24px",
    textAlign: "center",
    margin: "20px",
  },
  sectionContainer: {
    backgroundColor: "#000",
  },
};

export default CourseCarousel;
